import { render, staticRenderFns } from "./transmittals-lookup.vue?vue&type=template&id=01e75416"
import script from "./transmittals-lookup.vue?vue&type=script&lang=js"
export * from "./transmittals-lookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports